import useTableFilters from "@/hooks/useTableFilters";
import { useFetch } from "@/hooks/useFetch";
import CommonSelect from "components/select";
import { EMPLOYEE_FILTERS } from "components/employee/constants";
import UserCombobox from "components/directus/combobox/user";
import { fetchMilestoneStatuses } from "./api"; // Make sure this fetches milestone statuses
import { FilterActions } from "components/filter/actions";
import FilterWrapper from "components/filter/wrapper";
import FiltersList from "components/filter/list";

export default function MilestoneFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  defaultFilters,
  clearFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      coordinator: undefined,
      status: undefined,
      ...defaultFilters,
    },
    defaultFilters
  });

  const {
    data: milestoneStatuses,
  } = useFetch({
    queryKey: ["milestone-statuses"],
    queryFn: fetchMilestoneStatuses,
  });

  return (
    <FiltersList>
      {/* Milestone Coordinator Filter */}
      <UserCombobox
        label="Milestone Coordinator"
        value={localFilters?.coordinator?._eq}
        onChange={(selectedItem) => {
          handleSetLocalFilters({
            coordinator: selectedItem ? { _eq: selectedItem } : undefined,
          });
        }}
        filter={EMPLOYEE_FILTERS.milestones_coordinating}
        dependenton={isOpen}
      />

      {/* Status Filter */}
      <FilterWrapper label="Status">
        <CommonSelect
          placeholder="Select"
          value={localFilters?.status?._eq}
          onValueChange={(selectedItem) =>
            handleSetLocalFilters({
              status: selectedItem
                ? { _eq: selectedItem?.id, __selectedItem: selectedItem }
                : undefined,
            })
          }
          items={milestoneStatuses}
          className="!w-full"
        />
      </FilterWrapper>

      {/* Action Buttons */}
      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </FiltersList>
  );
}
